import React from 'react';
import './index.scss';
import { report } from 'lib/utils/dataReport';
import { ATTA_REPORT } from 'lib/constants/atta';
import { showDebrisDetailDialog } from '../DebrisDetailDialog';

// 我的奖励--奖励tab页
const FramentPrizeInfoCard = ({ prizeInfo }) => {
  const { currencyIcon, currencyName, validAmount, expireTime, description, fragmentId } = prizeInfo;

  const handleShowFragmentDetail = () => {
    report(ATTA_REPORT.USER_REWARD.MYREWARD_FRAGMENT_CLICK, {
      prizeId: fragmentId,
    });
    showDebrisDetailDialog({
      info: {
        currencyName, usedAmount: validAmount, usedTime: expireTime,
        description, currencyIcon,
      },
    });
  };
  return (
    <div className="fragment-Info-card" onClick={handleShowFragmentDetail}>
      {validAmount > 1 && validAmount < 100 ? <div className="fragment-Info-card__amount">x{validAmount}</div> : null}
      {validAmount > 99 ? <div className="fragment-Info-card__big-amount">99+</div> : null}
      <div className={'fragment-Info-card__unopened unopned-flip'}>
        <div className={'fragment-Info-card__unopened__image'} />
      </div>
      <div className='fragment-Info-card__opened open-flip'>
        <div className='fragment-Info-card__opened__image-container'>
          <img className="fragment-Info-card__opened__image" src={currencyIcon} alt="[图片]" />
        </div>
        <div className="fragment-Info-card__opened__text">{currencyName}</div>
      </div>
    </div >
  );
};

export default FramentPrizeInfoCard;

